import React from "react";

import Divider from "@material-ui/core/Divider";
import Hidden from "@material-ui/core/Hidden";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import { makeStyles } from "@material-ui/core/styles";

import DashboardIcon from "@material-ui/icons/Dashboard";
//import NearMeIcon from "@material-ui/icons/NearMe";
import PlaceIcon from "@material-ui/icons/Place";
import TerrainIcon from "@material-ui/icons/Terrain";
import LocalActivityIcon from "@material-ui/icons/LocalActivity";
// import HelpIcon from "@material-ui/icons/Help";
import CategoryIcon from "@material-ui/icons/Category";
import BlockIcon from "@material-ui/icons/Block";
import PersonPinIcon from "@material-ui/icons/PersonPin";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import AllInclusiveIcon from "@material-ui/icons/AllInclusive";
import CodeIcon from "@material-ui/icons/Code";
//import AppIcon from "@material-ui/icons/Apps";

import { Link } from "react-router-dom";
import { withRouter } from "react-router";
import User from "./user-tile";
import { MENU_DRAWER_WIDTH } from "../../config";
import SubMenu from "./submenu";

import { permissions, types, checkAcl } from "../../utils/acl"

const drawerWidth = MENU_DRAWER_WIDTH;

const useStyles = makeStyles((theme) => ({
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
  },
  icon: { fontSize: "small" },
  listItemIcon: {
    minWidth: "25px",
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
}));



function Menu(props) {

  const LOCATION_ACCESS = checkAcl({ p: permissions.LOCATION_MANAGEMENT, t: types.VIEW_ONLY });
  const DASHBOARD_ACCESS = checkAcl({ p: permissions.ADMIN_WEB_DASHBOARD, t: types.VIEW_ONLY });
  const CATEGORY_ACCESS = checkAcl({ p: permissions.CATEGORY_MANAGEMENT, t: types.VIEW_ONLY });
  const ACL_ACCESS = checkAcl({ p: permissions.ADMIN_WEB_USER_MANAGEMENT, t: types.VIEW_ONLY });
  const TRAVALOURS_ACCESS = checkAcl({ p: permissions.TRAVALOUR_USER_MANAGEMENT, t: types.VIEW_ONLY });
  const USER_POSTS_ACCESS = checkAcl({ p: permissions.TRAVALOUR_USER_POSTS, t: types.VIEW_ONLY });
  const ADMIN_AREA_ACCESS = checkAcl({ p: permissions.ADMINISTRATIVE_AREA_MANAGEMENT, t: types.VIEW_ONLY });
  const SPAM_ACCESS = checkAcl({ p: permissions.SPAM_MANAGEMENT, t: types.VIEW_ONLY });
  const SYSTEM_ACCESS = checkAcl({ p: permissions.SYSTEM_SETTINGS_MANAGEMENT, t: types.VIEW_ONLY });
  const DEV_ACCESS = checkAcl({ p: permissions.DEV_SETTINGS, t: types.VIEW_ONLY });
  const AMENITIES_ACCESS = checkAcl({ p: permissions.AMENITIES, t: types.VIEW_ONLY });

  const {
    location: { pathname },
  } = props;
  const classes = useStyles();

  const admSubmenu = [
    {
      id: 1,
      name: "Search",
      to: "/adm-areas",
      hasAccess: ADMIN_AREA_ACCESS
    },
    {
      id: 2,
      name: "Adm Area Comments",
      to: "/adm-areas/comment/list",
      hasAccess: ADMIN_AREA_ACCESS
    }
  ];

  const locationSubmenu = [
    {
      id: 1,
      name: "Search",
      to: "/location/search",
      hasAccess: LOCATION_ACCESS
    },
    {
      id: 2,
      name: "Add",
      to: "/location/add",
      hasAccess: LOCATION_ACCESS
    },
    {
      id: 3,
      name: "Search By User",
      to: "/location/search/user",
      hasAccess: LOCATION_ACCESS
    },
    {
      id: 4,
      name: "Place ID Finder",
      to: "/location/google-place-id-finder",
      hasAccess: LOCATION_ACCESS
    },
    {
      id: 5,
      name: "Location Comments",
      to: "/location/comment/list",
      hasAccess: LOCATION_ACCESS
    },
  ];

  const travaloursSubmenu = [
    {
      id: 1,
      name: "Search Travalour",
      to: "/travalour/search",
      hasAccess: TRAVALOURS_ACCESS
    },
    {
      id: 2,
      name: "Articles",
      to: "/article/search?status=1&sort=date&order=desc",
      hasAccess: USER_POSTS_ACCESS
    },
    {
      id: 3,
      name: "Travelcards",
      to: "/travel-card/search?status=1&sort=date&order=desc",
      hasAccess: USER_POSTS_ACCESS
    },
    {
      id: 4,
      name: "Trips",
      to: "/trip/search?status=1&sort=date&order=desc",
      hasAccess: USER_POSTS_ACCESS
    },
    {
      id: 5,
      name: "Account Delete Requests",
      to: "/travalour/account-del-req",
      hasAccess: TRAVALOURS_ACCESS
    },
    {
      id: 6,
      name: "Feedback",
      to: "/feedback?status=0&sort=date&order=desc",
      hasAccess: TRAVALOURS_ACCESS
    },
  ];

  const aclSubmenu = [
    {
      id: 1,
      name: "Users",
      to: "/acl/users",
      hasAccess: ACL_ACCESS
    },
    {
      id: 2,
      name: "Roles",
      to: "/acl/roles",
      hasAccess: ACL_ACCESS
    },
  ];

  const systemSubmenu = [
    {
      id: 1,
      name: "Terms & Conditions",
      to: "/sys/documents/1",
      hasAccess: SYSTEM_ACCESS
    },
    {
      id: 2,
      name: "Privacy Policy",
      to: "/sys/documents/2",
      hasAccess: SYSTEM_ACCESS
    },
    {
      id: 3,
      name: "Cookie Policy",
      to: "/sys/documents/3",
      hasAccess: SYSTEM_ACCESS
    },
    {
      id: 4,
      name: "FAQ",
      to: "/sys/documents/4",
      hasAccess: SYSTEM_ACCESS
    },
  ];

  const devSubmenu = [
    {
      id: 1,
      name: "API Docs",
      to: "/dev/api-docs",
      hasAccess: DEV_ACCESS
    },
    {
      id: 2,
      name: "Websocket Client",
      to: "/dev/ws-client",
      hasAccess: DEV_ACCESS
    }
  ];

  return (
    <div>
      <Hidden smDown>
        <div className={classes.toolbar} />
      </Hidden>
      <User />
      <Divider />
      <MenuList>
        {DASHBOARD_ACCESS &&
          <MenuItem
            component={Link}
            to="/dashboard"
            selected={"/dashboard" === pathname}
          >
            <ListItemIcon className={classes.listItemIcon}>
              <DashboardIcon className={classes.icon} />
            </ListItemIcon>
            <ListItemText
              primary="Dashboard"
            // primaryTypographyProps={{ variant: "overline" }}
            />
          </MenuItem>}
        {ADMIN_AREA_ACCESS &&
          <SubMenu items={admSubmenu} menuPrefix={["adm-areas"]}>
            <ListItemIcon className={classes.listItemIcon}>
              <TerrainIcon className={classes.icon} />
            </ListItemIcon>
            <ListItemText
              primary="Administrative Areas"
            // primaryTypographyProps={{ variant: "overline" }}
            />
          </SubMenu>}
        {/* {ADMIN_AREA_ACCESS &&
          <MenuItem
            component={Link}
            to="/adm-areas"
            selected={"/adm-areas" === pathname}
          >
            <ListItemIcon className={classes.listItemIcon}>
              <TerrainIcon className={classes.icon} />
            </ListItemIcon>
            <ListItemText
              primary="Administrative Areas"
              primaryTypographyProps={{ variant: "overline" }}
            />
          </MenuItem>} */}
        {CATEGORY_ACCESS &&
          <MenuItem
            component={Link}
            to="/category"
            selected={"/category" === pathname}
          >
            <ListItemIcon className={classes.listItemIcon}>
              <CategoryIcon className={classes.icon} />
            </ListItemIcon>
            <ListItemText
              primary="Categories"
            // primaryTypographyProps={{ variant: "overline" }}
            />
          </MenuItem>}
        {LOCATION_ACCESS &&
          <SubMenu items={locationSubmenu} menuPrefix={["location"]} >
            <ListItemIcon className={classes.listItemIcon}>
              <PlaceIcon className={classes.icon} />
            </ListItemIcon>
            <ListItemText
              primary="Location"
            // primaryTypographyProps={{ variant: "overline" }}
            />
          </SubMenu>}
        {AMENITIES_ACCESS &&
          <MenuItem
            component={Link}
            to="/activities/search"
            selected={"/activities/search" === pathname}
          >
            <ListItemIcon className={classes.listItemIcon}>
              <LocalActivityIcon className={classes.icon} />
            </ListItemIcon>
            <ListItemText
              primary="Activities"
            // primaryTypographyProps={{ variant: "overline" }}
            />
          </MenuItem>}
        {(TRAVALOURS_ACCESS || USER_POSTS_ACCESS) &&
          <SubMenu items={travaloursSubmenu} menuPrefix={["travalour", "travel-card", "trip", "feedback", "article"]}>
            <ListItemIcon className={classes.listItemIcon}>
              <PersonPinIcon className={classes.icon} />
            </ListItemIcon>
            <ListItemText
              primary="Travalour"
            // primaryTypographyProps={{ variant: "overline" }}
            />
          </SubMenu>}
        {SPAM_ACCESS &&
          <MenuItem
            component={Link}
            to="/spam?status=0"
            selected={"/spam" === pathname}
          >
            <ListItemIcon className={classes.listItemIcon}>
              <BlockIcon className={classes.icon} />
            </ListItemIcon>
            <ListItemText
              primary="Spam Reports"
            // primaryTypographyProps={{ variant: "overline" }}
            />
          </MenuItem>}
        {ACL_ACCESS &&
          <SubMenu items={aclSubmenu} menuPrefix={["acl"]}>
            <ListItemIcon className={classes.listItemIcon}>
              <PersonAddIcon className={classes.icon} />
            </ListItemIcon>
            <ListItemText
              primary="Access Control"
            // primaryTypographyProps={{ variant: "overline" }}
            />
          </SubMenu>}
        {SYSTEM_ACCESS &&
          <SubMenu items={systemSubmenu} menuPrefix={["sys"]}>
            <ListItemIcon className={classes.listItemIcon}>
              <AllInclusiveIcon className={classes.icon} />
            </ListItemIcon>
            <ListItemText
              primary="System Settings"
            // primaryTypographyProps={{ variant: "overline" }}
            />
          </SubMenu>}
        {DEV_ACCESS &&
          <SubMenu items={devSubmenu} menuPrefix={["dev"]}>
            <ListItemIcon className={classes.listItemIcon}>
              <CodeIcon className={classes.icon} />
            </ListItemIcon>
            <ListItemText
              primary="Developer"
            // primaryTypographyProps={{ variant: "overline" }}
            />
          </SubMenu>}
        {/* <MenuItem component={Link} to="/help" selected={"/help" === pathname}>
          <ListItemIcon className={classes.listItemIcon}>
            <HelpIcon className={classes.icon} />
          </ListItemIcon>
          <ListItemText
            primary="Help"
            primaryTypographyProps={{ variant: "overline" }}
          />
        </MenuItem> */}
        {/*<MenuItem component={Link} to="/test" selected={"/test" === pathname}>
          <ListItemIcon className={classes.listItemIcon}>
            <AppIcon className={classes.icon} />
          </ListItemIcon>
          <ListItemText
            primary="Test"
            primaryTypographyProps={{ variant: "overline" }}
          />
  </MenuItem>*/}
      </MenuList>
    </div>
  );
}

export default withRouter(Menu);
